
export default {
  props: {
    href: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      validator: (value) =>
        ['default', 'compact', 'no-padding'].includes(value),
      default: 'default',
    },
  },
  computed: {
    variantClass() {
      return `card-${this.variant}`
    },

    componentTag() {
      return this.href ? 'a' : 'div'
    },
  },
}
